<template>
  <div class="relative w-full text-gray-400 focus-within:text-gray-600">
    <template v-if="!solid">
      <div
        class="pointer-events-none absolute inset-y-0 left-0 flex items-center"
      >
        <MagnifyingGlassIcon class="size-5 shrink-0" aria-hidden="true" />
      </div>
      <input
        v-model="input"
        :id="id"
        :name="id"
        class="size-full border-0 bg-transparent py-2 pl-8 pr-3 text-gray-900 focus:outline-none focus:ring-0 focus:placeholder:text-gray-400 sm:text-sm"
        :placeholder="placeholder || $t('general.search')"
        type="search"
        autocomplete="off"
        :disabled="disabled"
        @focus="emit('focus', $event)"
        @blur="emit('blur', $event)"
      />
    </template>
    <Input
      v-else
      v-model="input"
      :id="id"
      :name="id"
      :prefix-icon="MagnifyingGlassIcon"
      :placeholder="placeholder || $t('general.search')"
      type="search"
      autocomplete="off"
      :disabled="disabled"
      @focus="emit('focus', $event)"
      @blur="emit('blur', $event)"
    />
  </div>
</template>

<script lang="ts" setup>
import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid';

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: undefined,
  },
  solid: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'focus', 'blur']);

const input = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});
</script>
